// Pasos de una actividad en el orden real del flujo: desde el paso inicial,
// siguiendo las transiciones "aprobado" (el campo orden no alcanza: dos pasos
// seguidos pueden compartirlo). Con pasos en paralelo se recorre por niveles.
// Los pasos que el camino no alcanza (p. ej. datos viejos) van al final.
//
// Las transiciones aceptan las dos formas en que llegan de la API:
// { origenPasoId, destinoPasoId } (portal cliente) o { origenId, destinoId,
// resultado } (flujo del admin). Si traen resultado, sólo cuentan las APROBADO.
export function pasosEnOrden(pasos = [], pasoInicialId, transiciones = []) {
  const porId = new Map(pasos.map((p) => [p.id, p]));
  const siguientes = new Map();
  transiciones.forEach((t) => {
    if (t.resultado && t.resultado !== "APROBADO") return;
    const origen = t.origenPasoId ?? t.origenId;
    const destino = t.destinoPasoId ?? t.destinoId;
    if (!destino) return;
    if (!siguientes.has(origen)) siguientes.set(origen, []);
    siguientes.get(origen).push(destino);
  });
  const orden = [];
  const vistos = new Set();
  let nivel = porId.has(pasoInicialId) ? [pasoInicialId] : [];
  while (nivel.length) {
    const proximo = [];
    nivel.forEach((id) => {
      if (vistos.has(id) || !porId.has(id)) return;
      vistos.add(id);
      orden.push(porId.get(id));
      proximo.push(...(siguientes.get(id) || []));
    });
    nivel = proximo;
  }
  pasos.filter((p) => !vistos.has(p.id)).forEach((p) => orden.push(p));
  return orden;
}
